import Button from '@components/Button/Button';
import Icon from '@components/icons/Icon';
import styles from '@components/InteriorDesignsFilters/InteriorDesignsFilters.styles';
import { useTranslation } from 'react-i18next';
import CategoriesFilterChip from '@features/categories/components/CategoriesSelectedFilters/chips/CategoriesFilterChip';
import { IInteriorDesignFilter } from '@features/cms/typescript';
import InspiratioNoResultsFound from '@components/InspiratioNoResultsFound/InspiratioNoResultsFound';
import useInflectedTranslation from '@hooks/useInflectedTranslation';
type PropsType = {
  filters: IInteriorDesignFilter[] | null;
  showFilters: (showFilters: boolean) => void;
  setFiltersState: (filters: IInteriorDesignFilter[]) => void;
  noResultsFound?: boolean;
  projectsCount?: number;
};
const InteriorDesignsFilters = ({
  filters,
  showFilters,
  setFiltersState,
  noResultsFound = false,
  projectsCount = 0
}: PropsType) => {
  const {
    t
  } = useTranslation('filters');
  const {
    t: tCommon
  } = useTranslation('common');
  const {
    getInflectedTranslation
  } = useInflectedTranslation();
  const handleResetFilter = (filter: IInteriorDesignFilter) => {
    if (!filters) return;
    const findIndex = filters.findIndex(f => f.type === filter.type && f.value === filter.value);
    if (findIndex !== -1) {
      const newFiltersState = [...filters];
      newFiltersState[findIndex].isChecked = !filter.isChecked;
      setFiltersState(newFiltersState);
    }
  };
  const handleResetFilterTypeSurface = () => {
    if (!filters) return;
    const newFiltersState = [...filters];
    newFiltersState.forEach(filter => {
      if (filter?.type === 'surface') {
        filter.isChecked = false;
      }
    });
    setFiltersState(newFiltersState);
  };
  const renderFilterTypeSurface = () => {
    if (!filters) return null;
    const surfaceCheckedFilters = filters?.filter(filter => filter.type === 'surface' && filter.isChecked);
    if (surfaceCheckedFilters && surfaceCheckedFilters.length > 0) {
      const values = surfaceCheckedFilters.map(filter => parseInt(filter.value, 10)).filter(v => !isNaN(v));
      if (values.length > 0) {
        const min = Math.min(...values);
        const max = Math.max(...values);
        return <CategoriesFilterChip key={`surface-${min}-${max}`} label={`${tCommon('surface')}: ${min} - ${max} m²`} onResetClick={() => handleResetFilterTypeSurface()} />;
      }
    }
    return null;
  };
  const renderFilterButton = (filter: IInteriorDesignFilter) => {
    if (!filter?.isChecked || filter.type === 'surface') return null;
    return <CategoriesFilterChip key={filter.value} label={filter.value} onResetClick={() => handleResetFilter(filter)} />;
  };
  return <div sx={styles.filtersContainer} id="filters-container">
      <Button variant="link" variantColor="dark" addSx={styles.button} onClick={() => showFilters(true)}>
        <Icon icon="FilterUnselected" size="24px" margin="0 16px 0 0" />
        <span>{t('filters')}</span>
      </Button>
      <div sx={styles.firstLine}>
        <div sx={styles.filtersList}>
          {filters?.length ? filters.map(filter => renderFilterButton(filter)).filter(Boolean) : null}
          {renderFilterTypeSurface()}
        </div>
        <div>
          {projectsCount} {getInflectedTranslation(projectsCount, 'projects')}
        </div>
      </div>
      {noResultsFound && <InspiratioNoResultsFound text1={tCommon('noResultsFoundTxt1')} text2={tCommon('noResultsFoundTxt2')} />}
    </div>;
};
export default InteriorDesignsFilters;